import React from 'react'
import classNames from 'classnames'

// util
import { splitPrice } from '@/util'
import { toNumber } from 'lodash'
// 样式
import PriceStyle from './Price.module.scss'

const Price = (props) => {
  const { price = '', style, toFixed = 2, extraClass ='', ...otherProps } = props
  const {unit, integer, decimals} = splitPrice(price)

  // 框类名
  const wrapClassName = classNames({
    [`${PriceStyle.price}`]: true,
    [`${extraClass}`]: extraClass !== '',
  })

  // 小数位处理
  const fixedDecimals = decimals.substring(0, toFixed)

  // 单位类名
  const unitClassName = classNames({
    [`${PriceStyle.unit}`]: true,
    unit: true,
  })

  // 整数类名
  const integerClassName = classNames({
    [`${PriceStyle.integer}`]: true,
    integer: true,
  })

  // 小数类名
  const decimalsClassName = classNames({
    [`${PriceStyle.decimals}`]: true,
    decimals: true,
  })

  return <p className={wrapClassName}
      style={style}
      {...otherProps}>
          <span className={unitClassName}>{unit}</span>
          {/* 传入的价格是数字则显示数字，非数字则显示传入的值 */}
          {
            toNumber(price) >= 0 ?  <>
              <span className={integerClassName}>{integer}
              </span>
              {
                fixedDecimals && <span className={decimalsClassName}>.{fixedDecimals}</span>
              }
            </> :
            <span className={integerClassName}>{price}</span>
          }
        </p>
}

export default Price